import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_INVOLVEMENTS_LOAD,
    ACTION_INVOLVEMENTS_LOAD_BY_ID,

    ACTION_INVOLVEMENTS_SAVE,

    ACTION_INVOLVEMENTS_CREATE,

    IInvolvementLoadAction,
    IInvolvementLoadByIdAction,
    IInvolvementLoadFailureAction,
    IInvolvementLoadSuccessAction,

    IInvolvementSaveAction,
    IInvolvementSaveSuccessAction,
    IInvolvementSaveFailureAction,

    IInvolvementCreateAction,
    IInvolvementCreateSuccessAction,
    IInvolvementCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/involvements";
import { involvementsApi } from "../services/involvement";


export const
    getInvolvementsEpic = (action$): Observable<IInvolvementLoadSuccessAction | IInvolvementLoadFailureAction> => {
        return action$
            .ofType(ACTION_INVOLVEMENTS_LOAD)
            .mergeMap((action: IInvolvementLoadAction) => {
                return involvementsApi
                    .getInvolvements()
                    .map(response =>
                        LoadSuccess(response.involvements, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInvolvementByIdEpic = (action$): Observable<IInvolvementLoadSuccessAction | IInvolvementLoadFailureAction> => {
        return action$
            .ofType(ACTION_INVOLVEMENTS_LOAD_BY_ID)
            .mergeMap((action: IInvolvementLoadByIdAction) => {
                return involvementsApi
                    .getInvolvementById(action.id)
                    .map(response =>
                        LoadSuccess(response.involvement, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInvolvementEpic = (action$): Observable<IInvolvementSaveSuccessAction | IInvolvementSaveFailureAction> => {
        return action$
            .ofType(ACTION_INVOLVEMENTS_SAVE)
            .mergeMap((action: IInvolvementSaveAction) => {
                return involvementsApi
                    .setInvolvement(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.involvement, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInvolvementEpic = (action$): Observable<IInvolvementCreateSuccessAction | IInvolvementCreateFailureAction> => {
        return action$
            .ofType(ACTION_INVOLVEMENTS_CREATE)
            .mergeMap((action: IInvolvementCreateAction) => {
                return involvementsApi
                    .createInvolvement()
                    .map(response =>
                        CreateSuccess(
                            response.involvement,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



